var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUpDownDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_8851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.06 4.99997H5.82L6.48 1.81997C6.56 1.44997 6.44 1.06997 6.18 0.799971C5.74 0.359971 5.03 0.359971 4.6 0.799971L0.6 4.79997C0.21 5.16997 0 5.67997 0 6.20997V12C0 13.1 0.9 14 2 14H7.92C8.72 14 9.44 13.52 9.76 12.79L11.9 7.78997C12.46 6.46997 11.49 4.99997 10.06 4.99997ZM22 9.99997H16.08C15.28 9.99997 14.56 10.48 14.24 11.21L12.1 16.21C11.54 17.53 12.5 19 13.94 19H18.18L17.52 22.18C17.44 22.55 17.56 22.93 17.82 23.2C18.26 23.64 18.97 23.64 19.4 23.2L23.4 19.2C23.78 18.82 23.99 18.32 23.99 17.79V12C24 10.9 23.1 9.99997 22 9.99997Z",
    fill: "#8D8D8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_8851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpDownDisabled);
export default __webpack_public_path__ + "static/media/thumbsUpDownDisabled.ac43316f.svg";
export { ForwardRef as ReactComponent };